import React from 'react';
import { Button, Card, CardActionArea, CardContent, Grid } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useStripeTerminal } from '../../hooks/useStripeTerminal';
import { LNA_STATES, useLocalNetworkAccess } from '../../hooks/useLocalNetworkAccess';
import LNAStatusBanner from '../LNAStatusBanner';

const PaymentTerminalForm = ({
    bookerData,
    cartItems,
    paymentIntent,
    setPaymentIntent,
    methodSlug
}) => {
    const { LNAState, requestLNA } = useLocalNetworkAccess();
    const { readers, loading, error, waitForReader, reset } = useStripeTerminal(methodSlug);

    if (LNAState !== LNA_STATES.GRANTED) {
        return <LNAStatusBanner LNAState={LNAState} requestLNA={requestLNA} />;
    }

    return (
        <Grid container>
            <Grid item xs={12} className="mb-4"></Grid>
            <Grid item xs={12}>
                <h3 className="mb-2">Terminal payment</h3>
                <h5>Choose the terminal which you want to checkout with:</h5>
                {loading ? (
                    <Grid container alignItems="center" spacing={2}>
                        <Grid item>
                            <CircularProgress />
                        </Grid>
                        <Grid item>{loading}</Grid>
                    </Grid>
                ) : error ? (
                    <div>
                        <p>{error.response ? error.response.body.message : error.message}</p>
                        <Button
                            variant="outlined"
                            color="primary"
                            onClick={() => {
                                reset();
                            }}
                        >
                            Restart
                        </Button>
                    </div>
                ) : paymentIntent ? (
                    <div>
                        <p>Card read succeeded, finish the transaction to transfer funds.</p>
                        <Button
                            variant="outlined"
                            color="primary"
                            onClick={async () => {
                                await reset();
                                setPaymentIntent(null);
                            }}
                        >
                            Cancel
                        </Button>
                    </div>
                ) : readers && readers.length > 0 ? (
                    <Grid container>
                        {readers.map((reader, index) => (
                            <Grid item xs={12} md={3} key={`${reader.id}-${index}`}>
                                <Card>
                                    <CardActionArea
                                        onClick={async () => {
                                            const result = await waitForReader(reader, {
                                                bookerData,
                                                cartItems
                                            });
                                            if (result) {
                                                setPaymentIntent(result.paymentIntent);
                                            }
                                        }}
                                    >
                                        <CardContent>{reader.label}</CardContent>
                                    </CardActionArea>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                ) : (
                    <div>No reader available.</div>
                )}
            </Grid>
        </Grid>
    );
};

export default PaymentTerminalForm;
